import { InjectionToken } from '@angular/core';

export const LOCATION = new InjectionToken<Location>('window.location');
export const SESSION_STORE = new InjectionToken<Storage>('sessionStore');
